import { useEffect, useRef, useState } from "react";
import Agent from "../../../Network/Agent";
import Select from "react-select";
import * as echarts from "echarts";
import ReactEcharts from "echarts-for-react";
import { use } from "react";
export default function LoadStatus({ compact = false }) {

    const [data, setData] = useState([]);
    const echarts_react_1 = useRef();
    const [options, setOption] = useState([])
    const [loadTenantData, setLoadTenantData] = useState('');
    const dcControllerRef = useRef(null);
    const tempControllerRef = useRef(null);
    const today = new Date().toISOString().slice(0, 10);
    const searchControllerRef = useRef(null);
    const [showModal, setShowModal] = useState(false);
    const [dcDateValue, setDcDateValue] = useState({ from: today, to: today });
    const [dcFilterType, setDcFilterType] = useState('last24hour');
    const delay = (ms) => new Promise((res) => setTimeout(res, ms));
    const [dc_kw_avg_hourly, setDcAvgHourly] = useState()
    const [tempDate2, setTempDate2] = useState(today);
    const [tempDate, setTempDate] = useState(today);
    const [loading, setLoading] = useState(true);
    const [selectedSite, setSelectedSite] = useState('');
    const arrayData = {
        'tenant_id': '',
        'site_id': '',
        'date': today,
        'to_date': today
    };

    const openDateModal = () => {

        setShowModal(true);
    };

    const fetchData = async () => {
        if (tempControllerRef.current) {
            tempControllerRef.current.abort(); // Cancel the previous request if it exists
        }
        const controller = new AbortController();
        tempControllerRef.current = controller;

        const signal = controller.signal; // Create a new controller for the current request

        Agent.MANAGEMENT_DASHBOARD.temperature_range(signal).then((response) => {
            const dataValue = response.data.data;
            setData(dataValue);
        }).catch((error) => {
            console.error("Error fetching ACS power status:", error);
        });
    }

    function handleSearch(inputsearch) {
        Agent.HOME.get_rms_tenants(inputsearch).then((response) => {
            //object with keys {id, tenant_id, tenant_name, name, value, site_id, customer_site_id})
            setOption(response.map((tenant) => ({
                value: tenant.id,
                label: tenant.name
            })));
            setSelectedSite(response[0]?.name || '');
            setLoadTenantData(response);
             arrayData.tenant_id = '';
             arrayData.site_id ='';

        }).catch((error) => {
            console.error("Error fetching RMS tenants:", error);
        });
    }

    function handleChange(inputValue) {
        if (!inputValue) {
            arrayData.tenant_id = '';
            arrayData.site_id = '';
           // loadDcPowerData();
           return;
        }
        const selectedTenant = loadTenantData.find(tenant => tenant.id === inputValue.value);
        if (selectedTenant) {
                setSelectedSite(selectedTenant.name);
            arrayData.tenant_id = selectedTenant.tenant_id || '';
            arrayData.site_id = selectedTenant.site_id || '';
            loadDcPowerData();
        }
    }
    

    function handleInputChange(inputValue) {
        if (!inputValue) return;

        handleSearch(inputValue);
        // setSearchTerm(selectedOption ? selectedOption.value : '');
        // handleSearch();
    }

    useEffect(() => {

        fetchData();
        handleSearch('');

    }, []);

  const option = {
        color: ['#008000', '#FFC300'],
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'cross',
                label: {
                    backgroundColor: '#6a7985'
                }
            }
        },
        legend: {
            data: ['Dc Power', 'Max.Threshold']
        },
        toolbox: {
            feature: {
                saveAsImage: {}
            }
        },
        grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
        },
        xAxis: [
            {
                type: 'category',
                boundaryGap: false,
                data: dc_kw_avg_hourly?.times,
                axisLabel: {
                    formatter: function (value, index) {
                        // Split the value by spaces to get time and date parts
                        var parts = value.split(' ');
                        var time = parts[0] + ' ' + parts[1]; // e.g., "00:00 AM"
                        var date = parts[2] + ' ' + parts[3]; // e.g., "01 Jul, 24"

                        // Only show the time label at intervals (e.g., every 12 hours)
                        if (index % 24 === 0) {
                            // return time + '\n' + date;
                            return date;
                        }
                        return '';
                    },
                    fontSize: 10,
                    rotate: 0,
                    interval: 0,
                    align: 'left'
                }
            }
        ],
        yAxis: [
            {
                name: 'Dc Power',
                nameLocation: 'middle',
                nameGap: 60,
                nameTextStyle: {
                    fontWeight: 'bold',
                    color: '#000000'
                },
                type: 'value',
                axisLine: {
                    lineStyle: {
                        color: '#000'
                    }
                },
                splitLine: {
                    lineStyle: {
                        color: '#ddd'
                    }
                },
                axisLabel: {
                    formatter: '{value} kW'
                },
                axisPointer: {
                    snap: true
                }
            }
        ],
        series: [
            {
                name: 'Dc Power',
                type: 'line',
                symbol: 'none',
                sampling: 'lttb',
                areaStyle: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        {
                            offset: 0,
                            color: 'rgba(51, 176, 16,0.8)'
                        },
                        {
                            offset: 1,
                            color: 'rgba(10, 247, 73,0.3)'
                        }
                    ])
                },
                emphasis: {
                    focus: 'series'
                },
                lineStyle: {
                    color: 'rgba(51, 176, 16,1)'
                },
                data: dc_kw_avg_hourly?.avg_data,
            },
            {
                name: 'Max.Threshold',
                type: 'line',
                symbol: 'none',
                sampling: 'lttb',
                areaStyle: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        {
                            offset: 0,
                            color: 'rgba(250, 218, 57,0.8)'
                        },
                        {
                            offset: 1,
                            color: 'rgba(58,77,233,0.3)'
                        }
                    ])
                },
                emphasis: {
                    focus: 'series'
                },
                lineStyle: {
                    color: 'rgba(250, 218, 57,1)'
                },
                data: dc_kw_avg_hourly?.max_data
            }
        ]
    };

        async function loadDcPowerData() {

        if (dcControllerRef.current) {
            dcControllerRef.current.abort();
        }

        const controller = new AbortController();
        dcControllerRef.current = controller;

        const signal = controller.signal;
        setLoading(true);

        const array_data = {
            'tenant_id': arrayData.tenant_id==''? loadTenantData[0]?.tenant_id || '' : arrayData.tenant_id,
            'site_id': arrayData.site_id==''? loadTenantData[0]?.site_id || '' : arrayData.site_id,
            'date': dcDateValue.from,
            'to_date': dcDateValue.to
        };

        await delay(200);
        try {
            Agent.SITE_DASHBOARD.dc_avg_kw_hourly(array_data, signal)
                .then((result) => {
                    if (result) {
                        // setLoading(false)

                        // console.log(result)
                        setDcAvgHourly(result);
                    } else {
                        // setLoading(false)
                        console.error("No result received");
                    }
                })
                .catch((err) => {
                    if (err.name === 'AbortError') {
                        console.log('Request was aborted');
                    } else {
                        console.error(err);
                    }
                })
                .finally(() => {
                    setLoading(false);
                });
            // Do something with result
        } catch (err) {
            setLoading(false)
            // console.error(err);
        }

    }

    useEffect(() => {
        if (loadTenantData) {
            loadDcPowerData();
        }
    }, [dcDateValue, loadTenantData]);

    const getDateOptionLabel = (range) => {
        if (!range?.from || !range?.to) {
            return 'Date';
        }
        if (range.from === range.to) {
            return `Date (${range.from})`;
        }
        return `Date (${range.from} to ${range.to})`;
    };

    return (
        <>

            <div className="row g-1">
                {!compact && (
                <div className="col-xl-6 col-md-6">
                    <div className="card flex-fill">
                        <div className="card-header">
                            <h6 className="card-title mb-0">Load Status</h6>
                        </div>
                        <div className="card-body m-0 p-0">
                            <table className="table table-bordered text-center">
                                <tbody><tr>
                                    <th style={{ fontSize: '12px' }}>Avg. Consumption(kW)</th>
                                    <th style={{ fontSize: '12px' }}>Site Count</th>
                                    <th style={{ fontSize: '12px' }}>BL</th>
                                    <th style={{ fontSize: '12px' }}>Robi</th>
                                    <th style={{ fontSize: '12px' }}>GP</th>
                                    <th style={{ fontSize: '12px' }}>Overload</th>
                                </tr>
                                    {data?.slab_counts &&
                                        Object.entries(data.slab_counts)
                                            .sort(([aKey], [bKey]) => {
                                                const aNum = parseFloat(aKey);
                                                const bNum = parseFloat(bKey);

                                                if (isNaN(aNum)) return -1; // keep ">4" on top
                                                if (isNaN(bNum)) return 1;

                                                return bNum - aNum; // descending order
                                            })
                                            .map(([key, count]) => (
                                                <tr key={key}>
                                                    <td style={{ fontSize: '12px' }}>{key}</td>
                                                    <td style={{ fontSize: '12px' }}>{count}</td>
                                                    <td style={{ fontSize: '12px' }}>
                                                        {data.operators?.[key]?.['1'] || 0}
                                                    </td>
                                                    <td style={{ fontSize: '12px' }}>
                                                        {data.operators?.[key]?.['3'] || 0}
                                                    </td>
                                                    <td style={{ fontSize: '12px' }}>
                                                        {data.operators?.[key]?.['4'] || 0}
                                                    </td>
                                                    <td style={{ fontSize: '12px' }}>
                                                        {data.overload_counts?.[key] || 0}
                                                    </td>
                                                </tr>
                                            ))}


                                </tbody>
                                <tfoot>
                                    <tr>
                                        <th style={{ fontSize: '12px' }}>Total</th>
                                        <th style={{ fontSize: '12px' }}>{Object.values(data?.slab_counts || {}).reduce((a, b) => a + b, 0)}</th>
                                        {/* BL Total */}
                                        <th style={{ fontSize: '12px' }}>
                                            {Object.values(data?.operators || {}).reduce((sum, slab) => sum + (slab?.['1'] || 0), 0)}
                                        </th>

                                        {/* Robi Total */}
                                        <th style={{ fontSize: '12px' }}>
                                            {Object.values(data?.operators || {}).reduce((sum, slab) => sum + (slab?.['3'] || 0), 0)}
                                        </th>

                                        {/* GP Total */}
                                        <th style={{ fontSize: '12px' }}>
                                            {Object.values(data?.operators || {}).reduce((sum, slab) => sum + (slab?.['4'] || 0), 0)}
                                        </th>

                                        {/* Overload Total */}
                                        <th style={{ fontSize: '12px' }}>
                                            {Object.values(data?.overload_counts || {}).reduce((a, b) => a + b, 0)}
                                        </th>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
                )}

                <div className={compact ? "col-12" : "col-xl-6 col-md-6"}>
                    <div className="card flex-fill">
                        <div className="card-header border-bottom bg-info">
                            <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                                <h6 className="card-title mb-0 text-white fw-bold">Range: 0kW - 2kW</h6>
                                <div>
                                    <Select
                                        placeholder="Search a Site..."
                                        onInputChange={handleInputChange}
                                        onChange={handleChange}
                                        options={options}
                                        isClearable
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="card-body p-0 m-0 position-relative">
                            {compact && loading && (
                                <div className="td-chart-loading">
                                    <span className="spinner-border spinner-border-sm" />
                                    <span>Loading graph...</span>
                                </div>
                            )}
                            <div className="">
                                <div className="card-header d-flex justify-content-between align-items-center">
                                    <h5>{selectedSite}</h5>
                                    <div className="d-flex gap-2">
                                        <select
                                            className="form-select form-select-sm"
                                            value={dcFilterType}
                                            onClick={() => {
                                                if (dcFilterType === 'date') {
                                                    openDateModal();
                                                }
                                            }}
                                            onChange={(e) => {
                                                setDcFilterType(e.target.value);
                                                if (e.target.value === 'date') {
                                                    openDateModal();
                                                }
                                            }}
                                        >
                                            <option value="last24hour">Last 24Hr</option>
                                            <option value="date">{getDateOptionLabel(dcDateValue)}</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="">
                                    <ReactEcharts ref={echarts_react_1} style={{ height: "300px" }} option={option} />

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            {/* Date Filter Modal */}
            {showModal && (
                <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Select Date</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => {
                                        setShowModal(false);
                                    }}
                                ></button>
                            </div>
                            <div className="modal-body">
                                <div className="mb-3">
                                    <label className="form-label">From Date</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        value={tempDate}
                                        onChange={(e) => setTempDate(e.target.value)}
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">To Date</label>
                                    <input type="date" className="form-control"
                                        value={tempDate2}
                                        onChange={(e) => setTempDate2(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => {
                                        setShowModal(false);
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-info"
                                    onClick={() => {

                                        setDcDateValue({ from: tempDate, to: tempDate2 });
                                        setShowModal(false);
                                    }}
                                >
                                    <i className="fa-solid fa-filter me-1"></i>
                                    Filter
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}